export enum eTitleEvidenceFeeType {
  fee = 'fee',
  percentage = 'percentage',
}
